import { Button, ButtonProps } from '@mui/material';
import { forwardRef, Ref } from 'react';
import { utmsButtonSx } from '@shared/constants/otherConstants';

const UtmsButton = forwardRef(({ sx, children, ...props }: ButtonProps, ref: Ref<HTMLButtonElement>) => {
    return (
        <Button
            ref={ref}
            sx={{
                ...utmsButtonSx,
                ...sx,
            }}
            {...props}
        >
            {children}
        </Button>
    );
});

export default UtmsButton;
